
export const FETCH_DOWNLOAD_REPORTS = 'FETCH_DOWNLOAD_REPORTS'
export const FETCHED_DOWNLOAD_REPORTS = 'FETCHED_DOWNLOAD_REPORTS'
export const FETCH_DOWNLOAD_DATA_WC_WI = 'FETCH_DOWNLOAD_DATA_WC_WI'
export const FETCH_DOWNLOAD_DMS_TO_RLB_POST = 'FETCH_DOWNLOAD_DMS_TO_RLB_POST'
export const FETCHED_DOWNLOAD_DATA_WC_WI = 'FETCHED_DOWNLOAD_DATA_WC_WI'
export const FETCH_DOWNLOAD_RECONCILIATION = 'FETCH_DOWNLOAD_RECONCILIATION'
export const FETCHED_DOWNLOAD_RECONCILIATION = 'FETCHED_DOWNLOAD_RECONCILIATION'
export const FETCHED_DOWNLOAD_DMS_TO_RLB_POST = 'FETCHED_DOWNLOAD_DMS_TO_RLB_POST'
export const SEARCH_LOCATION = 'SEARCH_LOCATION'
export const SEARCH_OUTLET = 'SEARCH_OUTLET'
export const FETCHED_LOCATION = 'FETCHED_LOCATION'
export const FETCHED_OUTLET = 'FETCHED_OUTLET'